import { Progress } from "@/components/ui/progress";

export default function ProgressBar({ 
  isProcessing, 
  processingImageId, 
  compressionProgress 
}) {
  if (!isProcessing && !processingImageId) return null;

  return (
    <div className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 sticky top-16 z-40 transition-colors duration-300">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                {processingImageId ? 'Compressing image...' : 'Processing images...'}
              </span>
              {compressionProgress > 0 && (
                <span className="text-sm font-medium text-blue-600 dark:text-blue-400">{compressionProgress}%</span>
              )}
            </div>
            <Progress value={compressionProgress || 0} className="h-2" />
          </div>
          <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-600 border-t-transparent"></div>
        </div>
      </div>
    </div>
  );
}
